/* eslint-disable multiline-ternary */
/* eslint-disable no-extra-parens */
import classnames from 'classnames'
import { getFirstChild } from '../../libs/typeGuards'
import { ComponentChildren } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from './interfaces'
import { isFunction } from 'underscore'

interface Props {
  type?: string
  align: string
  trigger: ComponentChildren
  items: ItemsList | GroupedItemsList
  displayListUpwards?: boolean
  hasSearch?: boolean
  triggerClass?: string
  disabled?: boolean
  children?: ComponentChildren
  newStyle?: boolean
  closeOnDropdownClick?: boolean
  className?: string
  showDefaultChildren?: boolean
  searchPlaceholderText?: string
  searchIconWidth?: number
  searchIconHeight?: number
}

const DropdownControl = ({
  type,
  align,
  trigger,
  items,
  displayListUpwards,
  hasSearch,
  triggerClass,
  disabled,
  children,
  newStyle,
  className,
  closeOnDropdownClick,
  showDefaultChildren,
  searchPlaceholderText,
  searchIconWidth,
  searchIconHeight
}: Props) => {
  const renderPropChildren = getFirstChild(children)
  return (
    <Dropdown
      closeOnDropdownClick={closeOnDropdownClick || false}
      popupName='control-dropdown'
      class={classnames(className, 'control-dropdown', {
        'control-dropdown--brand': newStyle
      })}
      trigger={trigger}
      triggerClass={triggerClass}
      disabled={disabled}
    >
      {showDefaultChildren ? (
        ({ close }: { close: () => void }) => {
          if (isFunction(renderPropChildren)) {
            return renderPropChildren({ close })
          }
          return (
            <DropdownList
              displayListUpwards={displayListUpwards}
              type={type}
              align={align}
              items={items}
              hasSearch={hasSearch ?? false}
              searchPlaceholderText={searchPlaceholderText}
              searchIconWidth={searchIconWidth}
              searchIconHeight={searchIconHeight}
            />
          )
        }
      ) : (
        <DropdownList
          displayListUpwards={displayListUpwards}
          type={type}
          align={align}
          items={items}
          hasSearch={hasSearch ?? false}
          searchPlaceholderText={searchPlaceholderText}
          searchIconWidth={searchIconWidth}
          searchIconHeight={searchIconHeight}
        />
      )}
    </Dropdown>
  )
}

export default DropdownControl
